import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
const quotesArticleUrl = 'https://knowledge.hubspot.com/articles/kcs_article/deals/how-do-i-create-quotes';
const QuotesPopoverEmptyState = () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "quotes",
  title: "draftPlugins.quotes.popover.zeroState.header",
  description: "draftPlugins.quotes.popover.zeroState.description",
  buttonLabel: "draftPlugins.quotes.popover.zeroState.button",
  buttonLink: quotesArticleUrl
});
export default QuotesPopoverEmptyState;